module.exports = "/static/assets/67f20864e89390c2b7520695b9a8a0eb.png";